<template>
    <nav class="nav_center2" style="padding: 0; background: cadetblue">
  <ul class="" style="list-style: none">
       <li
          :class="{ topmenuactive: activeTab === 'Gioithieu' }"
          @click="changeTab('Gioithieu')"
        >
          <a id="urlGioithieu" href="vi/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/gioithieu" style="color: white;">Giới thiệu</a>
        </li>
       
     <li
          :class="{ topmenuactive: activeTab === 'Thanhtoanthongminh' }"
          @click="changeTab('Thanhtoanthongminh')"
        >
          <a id="urlThanhtoanthongminh" href="vi/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/thanhtoanthongminh" style="color: white;">Thanh toán thông minh</a>
        </li>
          <li
          :class="{ topmenuactive: activeTab === 'Giaoducthongminh' }"
          @click="changeTab('Giaoducthongminh')" 
        >
          <a id="urlGiaoducthongminh" href="vi/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/giaoducthongminh" style="color: white;">Giáo dục thông minh</a>
        </li>
         <li
          :class="{ topmenuactive: activeTab === 'Giaothongthongminh' }"
          @click="changeTab('Giaothongthongminh')"
        >
          <a id="urlGiaothongthongminh" href="vi/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/giaothongthongminh" style="color: white;">Giao thông thông minh</a>
        </li>
          <li
          :class="{ topmenuactive: activeTab === 'Ytethongminh' }"
          @click="changeTab('Ytethongminh')"
        >
          <a id="urlYtethongminh" href="vi/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/ytethongminh" style="color: white;">Y tế thông minh</a>
        </li>
    <li
          :class="{ topmenuactive: activeTab === 'Dvcthongminh' }"
          @click="changeTab('Dvcthongminh')"
        >
          <a id="urlDvcthongminh" href="vi/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/dvcthongminh" style="color: white;">Dịch vụ công thông minh</a>
        </li>
       
      
        
       
       
        <!-- <li
          :class="{ topmenuactive: activeTab === 'Grok' }"
          @click="changeTab('Grok')"
        >
          <a id="urlGrok" href="vi/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/grok" style="color: white;">Grok</a>
        </li> -->
     
      
        <li 
          :class="{ topmenuactive: activeTab === 'Nongnghiepthongminh' }"
          @click="changeTab('Nongnghiepthongminh')"
        >
          <a id="urlNongnghiepthongminh" href="vi/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/nongnghiepthongminh"  style="color: white;">Nông nghiệp thông minh</a>
        </li>
      </ul>
    </nav>
<div class="wrapper row3 ">
    <main class="hoc container-fluid clear bv p-0">
   
          <!-- Dvcthongminh -->
          <div v-show="showThanhtoanthongminh" class="padding-top15">
        <div class="title-bai-viet " v-html="titleHtmlThanhtoanthongminh"></div>
        <div v-html="contentHtmlThanhtoanthongminh"></div>
      </div>
      <div v-show="showYtethongminh" class="padding-top15">
        <div class="title-bai-viet " v-html="titleHtmlYtethongminh"></div>
        <div v-html="contentHtmlYtethongminh"></div>
      </div>
      <div v-show="showGiaothongthongminh" class="padding-top15">
        <div class="title-bai-viet " v-html="titleHtmlGiaothongthongminh"></div>
        <div v-html="contentHtmlGiaothongthongminh"></div>
      </div>
      <div v-show="showGioithieu" class="padding-top15">
        <!-- <div class="title-bai-viet " v-html="titleHtmlGioithieu"></div> -->
        <div v-html="contentHtmlGioithieu"></div>
      </div>
      <div v-show="showGrok" class="padding-top15">
        <div class="title-bai-viet " v-html="titleHtmlGrok"></div>
        <div v-html="contentHtmlGrok"></div>
      </div>
      <div v-show="showGiaoducthongminh" class="padding-top15">
        <div class="title-bai-viet " v-html="titleHtmlGiaoducthongminh"></div>
        <div v-html="contentHtmlGiaoducthongminh"></div>
      </div>
      <div v-show="showNongnghiepthongminh" class="padding-top15">
        <div class="title-bai-viet " v-html="titleHtmlNongnghiepthongminh"></div>
        <div v-html="contentHtmlNongnghiepthongminh"></div>
      </div>
      <div v-show="showDvcthongminh" class="padding-top15">
        <div class="title-bai-viet " v-html="titleHtmlDvcthongminh"></div>
        <div v-html="contentHtmlDvcthongminh"></div>
      </div>
    
    </main>
  </div>

</template>
<script scope="this api replaced by slot-scope in 2.5.0+">
import { languages } from "@/components/languages";
import { apiChiTietBaiViet } from "@/components/listService";
import axios from "axios";


export default {
  components: {

  },
  data() {
    return {
      activeTab: 'Gioithieu',

      currentLanguage: languages.vi,
      lang: "",
      base64: "",
      base64Title: "",

      showThanhtoanthongminh: false,
      showYtethongminh: false,
      showGiaothongthongminh: false,
      showGioithieu: false,
      showGrok: false,
      showGiaoducthongminh: false,
      showNongnghiepthongminh: false,
      showDvcthongminh: false,
      showUngDungAI: false,

      titleHtmlAITaiLopHoc: "",
      contentHtmlAITaiLopHoc: "",
      titleHtml: "",
      contentHtml: "",
      titleHtmlTruongTaiTro: "",
      contentHtmlTruongTaiTro: "",
      titleHtmlTH: "",
      contentHtmlTH: "",
      titleHtmlTHCS: "",
      contentHtmlTHCS: "",
      titleHtmlTHPT: "",
      contentHtmlTHPT: "",
      titleHtmlLienHe: "",
      contentHtmlLienHe: "",
      titleHtmlLienCap: "",
      contentHtmlLienCap: "",

      titleHtmlDvcthongminh:"",
      titleHtmlThanhtoanthongminh:"",
      titleHtmlYtethongminh:"",
      titleHtmlGiaothongthongminh:"",
      titleHtmlGioithieu:"",
      titleHtmlGrok:"",
      titleHtmlGiaoducthongminh:"",
      titleHtmlNongnghiepthongminh:"",

      contentHtmlDvcthongminh:"",
      contentHtmlThanhtoanthongminh:"",
      contentHtmlYtethongminh:"",
      contentHtmlGioithieu:"",
      contentHtmlGiaothongthongminh:"",
      contentHtmlGrok:"",
      contentHtmlGiaoducthongminh:"",
      contentHtmlNongnghiepthongminh:"",
    };
  },
  mounted() {
    if (window.innerWidth <= 768) {
    this.isMenuVisible = false;
  } else {
    this.isMenuVisible = true;
  }
  if (!this.hasMounted) {
    this.hasMounted = true;
    this.lang = localStorage.getItem("languages") || "vi";  
    // this.performPostRequest("1755078954972F3zJG", "Gioithieu", this.lang);
    document.getElementById("urlDvcthongminh").setAttribute("href", this.lang+ "/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/dvcthongminh");
    document.getElementById("urlGiaothongthongminh").setAttribute("href", this.lang+ "/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/giaothongthongminh");
    document.getElementById("urlYtethongminh").setAttribute("href", this.lang+ "/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/ytethongminh");
    document.getElementById("urlThanhtoanthongminh").setAttribute("href", this.lang+ "/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/thanhtoanthongminh");
    document.getElementById("urlGiaoducthongminh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/giaoducthongminh");
    document.getElementById("urlNongnghiepthongminh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/nongnghiepthongminh");
    // document.getElementById("urlGrok").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/grok/");
    document.getElementById("urlGioithieu").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#chuongtrinhtaitro/gioithieu");
 
 
 
    const fragmentTab = window.location.hash.substring(1);
    console.log("fragmentTab "+ fragmentTab);
    
    if (fragmentTab === "chuongtrinhtaitro/dvcthongminh") {
      this.changeTab("Dvcthongminh");
    } else if (fragmentTab === "chuongtrinhtaitro/giaothongthongminh") {
      this.changeTab("Giaothongthongminh");
    } else if (fragmentTab === "chuongtrinhtaitro/ytethongminh") {
      this.changeTab("Ytethongminh");
    } else if (fragmentTab === "chuongtrinhtaitro/thanhtoanthongminh") {
      this.changeTab("Thanhtoanthongminh");
    }else if (fragmentTab ==="chuongtrinhtaitro/gioithieu") {
        this.changeTab("Gioithieu");
      }else if (fragmentTab ==="chuongtrinhtaitro/grok") {
        this.changeTab("Grok");
      }else if (fragmentTab ==="chuongtrinhtaitro/giaoducthongminh") {
        this.changeTab("Giaoducthongminh");
      }else if (fragmentTab ==="chuongtrinhtaitro/nongnghiepthongminh") {
        this.changeTab("Nongnghiepthongminh");
      }  else {
      // Nếu không phù hợp với bất kỳ tab nào, mặc định hiển thị tab gioiThieu
      this.changeTab("Gioithieu");
    }
}
  },
  created() {
  const savedLanguage = localStorage.getItem("languages") || "vi";
  if (savedLanguage && languages[savedLanguage]) {
    this.currentLanguage = languages[savedLanguage];
  }
},
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
    window.location.reload();
    },

    async performPostRequest(id, section) {
      this.lang = localStorage.getItem("languages") || "vi";

      try {
        // Thực hiện POST request
        const response = await axios.post(apiChiTietBaiViet, {
          id: id,
          langId: "0",
        });
        if (this.lang === "vi") {
          this.base64 = response.data.result.content_vi;
          this.base64Title = response.data.result.title_vi;
        } else if (this.lang === "en") {
          this.base64 = response.data.result.content_en;
          this.base64Title = response.data.result.title_en;
        }else if (this.lang === "cn") {
        this.base64 = response.data.result.content_cn;
        this.base64Title = response.data.result.title_cn;
      }else if (this.lang === "kr") {
        this.base64 = response.data.result.content_kr;
        this.base64Title = response.data.result.title_kr;
      }

        var title = atob(this.base64Title);
        var decodedString = atob(this.base64);

        // Store separately for each section
     if (section === "Thanhtoanthongminh") {
          this.titleHtmlThanhtoanthongminh = decodeURIComponent(escape(title));
          this.contentHtmlThanhtoanthongminh = decodeURIComponent(escape(decodedString));
        } else if (section === "Ytethongminh") {
          this.titleHtmlYtethongminh = decodeURIComponent(escape(title));
          this.contentHtmlYtethongminh= decodeURIComponent(escape(decodedString));
        } else if (section === "Giaothongthongminh") {
          this.titleHtmlGiaothongthongminh = decodeURIComponent(escape(title));
          this.contentHtmlGiaothongthongminh = decodeURIComponent(escape(decodedString));
        } else if (section === "Gioithieu") {
          this.titleHtmlGioithieu = decodeURIComponent(escape(title));
          this.contentHtmlGioithieu = decodeURIComponent(escape(decodedString));
        }else if (section === "Grok") {
          this.titleHtmlGrok = decodeURIComponent(escape(title));
          this.contentHtmlGrok= decodeURIComponent(escape(decodedString));
        } else if (section === "Giaoducthongminh") {
          this.titleHtmlGiaoducthongminh = decodeURIComponent(escape(title));
          this.contentHtmlGiaoducthongminh = decodeURIComponent(escape(decodedString));
        } else if (section === "Nongnghiepthongminh") {
          this.titleHtmlNongnghiepthongminh = decodeURIComponent(escape(title));
          this.contentHtmlNongnghiepthongminh = decodeURIComponent(escape(decodedString));
        }else if (section === "Dvcthongminh") {
          this.titleHtmlDvcthongminh = decodeURIComponent(escape(title));
          this.contentHtmlDvcthongminh = decodeURIComponent(escape(decodedString));
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    changeTab(tab) {
    this.lang = localStorage.getItem("languages") || "vi";
    this.activeTab = tab;

    // Reset tất cả các tab về false
    this.showThanhtoanthongminh = false;
    this.showYtethongminh = false;
    this.showGiaothongthongminh = false;
    this.showGioithieu = false;
    this.showGrok = false;
    this.showGiaoducthongminh = false;
    this.showNongnghiepthongminh = false;
    this.showDvcthongminh = false;

    // Chỉ bật tab đang chọn
    if (tab === "Thanhtoanthongminh") this.showThanhtoanthongminh = true;
    else if (tab === "Ytethongminh") this.showYtethongminh = true;
    else if (tab === "Giaothongthongminh") this.showGiaothongthongminh = true;
    else if (tab === "Gioithieu") this.showGioithieu = true;
    else if (tab === "Grok") this.showGrok = true;
    else if (tab === "Giaoducthongminh") this.showGiaoducthongminh = true;
    else if (tab === "Nongnghiepthongminh") this.showNongnghiepthongminh = true;
    else if (tab === "Dvcthongminh") this.showDvcthongminh = true;

    // Gọi API cho bài viết tương ứng
    this.performPostRequest(this.getPostId(tab), tab, this.lang);
  },
    getPostId(tab) {
      // Sử dụng một đối tượng để ánh xạ tab với id của bài viết tương ứng
      const postIdMap = {
       
        Thanhtoanthongminh: "1749203550578RBETn",
        Ytethongminh: "1752550189626581gF",
        Giaothongthongminh: "1752549754421nvevM",
        Gioithieu: "1755078954972F3zJG",
        Grok: "1755078954972F3zJG",
        Giaoducthongminh: "1754639247965v9vpG",
        Nongnghiepthongminh: "1756107534123QZOKu",
        Dvcthongminh: "1752549940885h0Sxh",
      };

      return postIdMap[tab];
    },
  },
};
</script>

<style scoped>
  .title-bai-viet{display: block;}
  .hiddentitle{display: none;}
</style>
